<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
import defaultSettings from '@/config/defaultSettings'
import storage from 'store'
// import './qiankun'
// import reload from '@/mixins/reload'
import Vue from 'vue';
export default {
  // provide () {
  //  return {
  //    reload: this.reload
  //  }
  // },
  // mixins: [reload],
  data () {
    return {
      // isRouterAlive: true
    }
  },
  created () {
    // this.connectMqtt()
  },
  computed: {
    locale () {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && (setDocumentTitle(`${i18nRender(title)} - ${domTitle}`))

      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    }
  },

  updated () {
    document.title = this.$t(defaultSettings.title)
  },
  methods: {
    /**
* @desc mqtt连接
* @author 刘
* @time 2023年06月02日 18:31:19 星期五
*/
    connectMqtt () {
      const that = this
      var mqtt = require('mqtt/dist/mqtt.js')
      let client = this.$store.getters.client
      console.log(client, 'clientclientclientclientmqtt===========================全局');
      if (!client) {
        const mqttUrl = 'ws://139.196.79.66:7084/mqtt'
        // client = mqtt.connect('ws://47.104.102.88:8083/bao/bao-dev')
        client = mqtt.connect(mqttUrl, {
          protocolVersion: 4,
          reconnectPeriod: 100,
          connectTimeout: 30 * 1000,
          resubscribe: true,
          keepalive: 3,
          clientId:
            'mqttjs_' +
            Math.random()
              .toString(16)
              .substr(2, 8)
        })
        client.on('connect', function () {
          console.log('on connect', new Date().getTime())
          let subscribe = ['300823100109/web/pub/01', '300823100109/web/pub/02']
          console.log(client, 'client测试mqtt 数据---');

        }).on('reconnect', function () {
          // uni.showLoading({
          // 	title:'加载中...',
          // 	mask:true
          // })
          // setTimeout(function() {
          // 	uni.hideLoading()
          // }, 3000);
          console.log('重新连接', new Date().getTime())
        }).on('close', function (err) {
          // that.setIsMqttConnect(false)
          console.log('链接断开>>>>', err)
        }).on('error', function (err) {
          console.log('on error', err)
        }).on('end', function () {
          // that.setIsMqttConnect(false)
          console.log('on end')
        })
        this.$store.commit('SET_CLIENT', client)
      }

    },
    // reload() {
    //   this.isRouterAlive = false
    //   this.$nextTick(function() {
    //     this.isRouterAlive = true
    //   })
    // }

  }
}
</script>
<style lang="less">
:root {
  --Tabs--line-color: #1C1F27 !important;
  --Tabs--line-fontSize: 1.8vh !important;
  --Tabs--line-fontWeight: bold !important;
  --Tabs--line-lineHeight: 2.2vh !important;

  // --Tabs--line-onHove-color:#1C1F27 !important;
  --Tabs--line-hover-fontSize: 1.8vh !important;
  --Tabs--line-hover-fontWeight: bold !important;
  --Tabs--line-hover-lineHeight: 2.2vh !important;

  // --Tabs--line-active-color:#1C1F27 !important;
  --Tabs--line-active-fontSize: 1.8vh !important;
  --Tabs--line-active-fontWeight: bold !important;
  --Tabs--line-active-lineHeight: 2.2vh !important;

  // --Table-thead-fontSize: 18px;
  // --Table-thead-color: #000000;

  --Table-searchableForm-backgroundColor: transparent !important;

  // --Form--horizontal-label-widthBase: auto !important;

  --Pagination-height: 1.9rem;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #DFE1E6;
  // -webkit-box-shadow: inset 0 0 5px rgb(0 21 8.2%);
  // box-shadow: inset 0 0 5px rgb(0 21 8.2%);
  border-radius: 6px 6px 6px 6px;
}

.is-modalOpened {
  overflow: auto !important;
}
</style>
